import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a23a8f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-student-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Student", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Add New Student", -1))
const _hoisted_5 = { class: "steps-indicator" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "step-number" }
const _hoisted_8 = { class: "step-label" }
const _hoisted_9 = { class: "form-step" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Personal Information", -1))
const _hoisted_12 = { class: "form-grid" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_15 = {
  key: 0,
  class: "error-message"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_18 = {
  key: 0,
  class: "error-message"
}
const _hoisted_19 = { class: "form-section" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Address Information", -1))
const _hoisted_21 = { class: "form-grid" }
const _hoisted_22 = { class: "form-group full-width" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addressLine1" }, "Street Address", -1))
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City", -1))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select State", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "zip" }, "ZIP Code", -1))
const _hoisted_32 = { class: "form-step" }
const _hoisted_33 = { class: "form-section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Selection", -1))
const _hoisted_35 = { class: "school-search" }
const _hoisted_36 = {
  key: 0,
  class: "schools-list"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "school-info" }
const _hoisted_39 = {
  key: 0,
  class: "school-select"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, "✓", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "no-results"
}
const _hoisted_43 = { class: "form-step" }
const _hoisted_44 = { class: "form-section" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Student Needs", -1))
const _hoisted_46 = { class: "needs-container" }
const _hoisted_47 = { class: "needs-input" }
const _hoisted_48 = ["onKeydown"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "common-needs" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Common Needs:", -1))
const _hoisted_52 = { class: "common-needs-list" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "selected-needs"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Selected Needs:", -1))
const _hoisted_56 = { class: "needs-tags" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "form-section" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Additional Comments", -1))
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { class: "form-navigation" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "←", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "→", -1))
const _hoisted_64 = {
  key: 2,
  type: "submit",
  class: "submit-button"
}

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { API_URL } from "../config";
import type { OrganizationRecord } from "../types";

// Form state

export default /*#__PURE__*/_defineComponent({
  __name: 'AddStudentView',
  setup(__props) {

const student = ref({
  firstName: "",
  lastName: "",
  addressLine1: "",
  city: "",
  state: "",
  zip: "",
  comments: "",
  needs: "",
  schoolId: "",
});

// Form validation
const errors = ref({
  firstName: "",
  lastName: "",
});

// Steps configuration
const steps = [
  { number: 1, label: "Personal Info" },
  { number: 2, label: "School" },
  { number: 3, label: "Needs & Comments" },
];

const currentStep = ref(1);
const totalSteps = steps.length;

// Schools handling
const schools = ref<OrganizationRecord[]>([]);
const schoolSearch = ref("");

// Needs handling
const needsArray = ref<string[]>([]);
const newNeed = ref("");
const commonNeeds = [
  "Special Education",
  "ESL Support",
  "Speech Therapy",
  "Physical Therapy",
  "Occupational Therapy",
  "Behavioral Support",
  "Academic Support",
  "Transportation",
  "Assistive Technology",
  "Medical Support",
];

// US States
const states = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

const router = useRouter();

// Computed properties
const filteredSchools = computed(() => {
  const searchTerm = schoolSearch.value.toLowerCase();
  return schools.value.filter(
    (school) =>
      school.name.toLowerCase().includes(searchTerm) ||
      school.address.toLowerCase().includes(searchTerm)
  );
});

// Methods
const validateField = (field: keyof typeof errors.value) => {
  errors.value[field] = "";
  if (field === "firstName" && !student.value.firstName.trim()) {
    errors.value.firstName = "First name is required";
  }
  if (field === "lastName" && !student.value.lastName.trim()) {
    errors.value.lastName = "Last name is required";
  }
};

const validateStep = () => {
  if (currentStep.value === 1) {
    validateField("firstName");
    validateField("lastName");
    return !errors.value.firstName && !errors.value.lastName;
  }
  return true;
};

const goToStep = (step: number) => {
  if (step < currentStep.value || validateStep()) {
    currentStep.value = step;
  }
};

const nextStep = () => {
  if (validateStep() && currentStep.value < totalSteps) {
    currentStep.value++;
  }
};

const previousStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
};

const selectSchool = (school: { id: number }) => {
  student.value.schoolId = school.id;
};

const addNeed = () => {
  const trimmedNeed = newNeed.value.trim();
  if (trimmedNeed && !needsArray.value.includes(trimmedNeed)) {
    needsArray.value.push(trimmedNeed);
  }
  newNeed.value = "";
};

const toggleCommonNeed = (need: string) => {
  const index = needsArray.value.indexOf(need);
  if (index === -1) {
    needsArray.value.push(need);
  } else {
    needsArray.value.splice(index, 1);
  }
};

const removeNeed = (index: number) => {
  needsArray.value.splice(index, 1);
};

const fetchSchools = async () => {
  try {
    const response = await fetch(`${API_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      schools.value = await response.json();
    }
  } catch (error) {
    console.error("Error fetching schools:", error);
  }
};

const submitForm = async () => {
  if (!validateStep()) return;

  try {
    student.value.needs = needsArray.value.join(", ");
    const response = await fetch(`${API_URL}/students`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(student.value),
    });

    if (response.ok) {
      router.push("/students");
    } else {
      const error = await response.json();
      alert(`Error: ${error.message}`);
    }
  } catch (error) {
    console.error("Error adding student:", error);
    alert("An error occurred while adding the student.");
  }
};

onMounted(() => {
  fetchSchools();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/students" }, {
        default: _withCtx(() => [
          _createTextVNode("Students")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
        return _createElementVNode("div", {
          key: step.number,
          class: _normalizeClass(["step", {
          active: currentStep.value === step.number,
          completed: currentStep.value > step.number,
        }]),
          onClick: ($event: any) => (goToStep(step.number))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(step.number), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(step.label), 1)
        ], 10, _hoisted_6)
      }), 64))
    ]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      class: "add-form"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((student.value.firstName) = $event)),
                id: "firstName",
                class: _normalizeClass({ error: errors.value.firstName }),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (validateField('firstName')))
              }, null, 34), [
                [_vModelText, student.value.firstName]
              ]),
              (errors.value.firstName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors.value.firstName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((student.value.lastName) = $event)),
                id: "lastName",
                class: _normalizeClass({ error: errors.value.lastName }),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (validateField('lastName')))
              }, null, 34), [
                [_vModelText, student.value.lastName]
              ]),
              (errors.value.lastName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.value.lastName), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((student.value.addressLine1) = $event)),
                id: "addressLine1"
              }, null, 512), [
                [_vModelText, student.value.addressLine1]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((student.value.city) = $event)),
                id: "city"
              }, null, 512), [
                [_vModelText, student.value.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((student.value.state) = $event)),
                id: "state"
              }, [
                _hoisted_28,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                  return _createElementVNode("option", {
                    key: state,
                    value: state
                  }, _toDisplayString(state), 9, _hoisted_29)
                }), 64))
              ], 512), [
                [_vModelSelect, student.value.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((student.value.zip) = $event)),
                id: "zip",
                pattern: "[0-9]*",
                maxlength: "5"
              }, null, 512), [
                [_vModelText, student.value.zip]
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schoolSearch).value = $event)),
              placeholder: "Search schools by name or address...",
              class: "search-input"
            }, null, 512), [
              [_vModelText, schoolSearch.value]
            ]),
            (filteredSchools.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSchools.value, (school) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: school.id,
                      class: _normalizeClass(["school-item", { selected: school.id === student.value.schoolId }]),
                      onClick: ($event: any) => (selectSchool(school))
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("h4", null, _toDisplayString(school.name), 1),
                        _createElementVNode("p", null, _toDisplayString(school.address), 1)
                      ]),
                      (school.id === student.value.schoolId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_37))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_42, " No schools found matching your search "))
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newNeed).value = $event)),
                onKeydown: _withKeys(_withModifiers(addNeed, ["prevent"]), ["enter"]),
                placeholder: "Type a need and press Enter",
                class: "need-input"
              }, null, 40, _hoisted_48), [
                [_vModelText, newNeed.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: addNeed,
                class: "add-need-btn",
                disabled: !newNeed.value.trim()
              }, " Add ", 8, _hoisted_49)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(commonNeeds, (need) => {
                  return _createElementVNode("button", {
                    key: need,
                    type: "button",
                    class: _normalizeClass(["common-need-btn", { selected: needsArray.value.includes(need) }]),
                    onClick: ($event: any) => (toggleCommonNeed(need))
                  }, _toDisplayString(need), 11, _hoisted_53)
                }), 64))
              ])
            ]),
            (needsArray.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(needsArray.value, (need, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "need-tag"
                      }, [
                        _createTextVNode(_toDisplayString(need) + " ", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "remove-need",
                          onClick: ($event: any) => (removeNeed(index))
                        }, " × ", 8, _hoisted_57)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((student.value.comments) = $event)),
              rows: "4",
              placeholder: "Add any additional notes or comments about the student..."
            }, null, 512), [
              [_vModelText, student.value.comments]
            ])
          ])
        ])
      ], 512), [
        [_vShow, currentStep.value === 3]
      ]),
      _createElementVNode("div", _hoisted_61, [
        (currentStep.value > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: previousStep,
              class: "secondary-button"
            }, [
              _hoisted_62,
              _createTextVNode(" Previous ")
            ]))
          : _createCommentVNode("", true),
        (currentStep.value < _unref(totalSteps))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: nextStep,
              class: "primary-button"
            }, [
              _createTextVNode(" Next "),
              _hoisted_63
            ]))
          : _createCommentVNode("", true),
        (currentStep.value === _unref(totalSteps))
          ? (_openBlock(), _createElementBlock("button", _hoisted_64, " Add Student "))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}
}

})